export default "__VITE_ASSET__eb4b7b00__"